export default {
  terms:
    "Effettuando l'ordine, accetti i nostri <TermsLink>Termini e condizioni</TermsLink> e la nostra <PrivacyPolicyLink>Informativa sulla privacy</PrivacyPolicyLink>.",
};
